import { TextSource } from './types';

/**
 * Texte der Seite „Karriere".
 *
 * Die dritte Stelle ist bewusst auf Polnisch ausgeschrieben — sie richtet sich an
 * polnischsprachige Bewerber. Beim Bearbeiten also nicht „übersetzen".
 */
export const KARRIERE: TextSource = {
  'karriere.hero.eyebrow': 'Karriere',
  'karriere.hero.titel': 'Werde Teil',
  'karriere.hero.titel-akzent': 'unseres Teams.',
  'karriere.hero.absatz-1':
    'Bist du auf der Suche nach einem Job im Umfeld der häuslichen Versorgung von pflegebedürftigen Menschen? Dann bist du bei uns genau richtig! Wir suchen ständig nach freundlichen und kompetenten Mitarbeiter*innen, die unser Team bereichern.',
  'karriere.hero.absatz-2':
    'Entdecke vielfältige Möglichkeiten, deine Fähigkeiten einzubringen und dich weiterzuentwickeln — mit attraktiven Arbeitsbedingungen und flexiblen Arbeitszeiten.',
  'karriere.hero.cta': 'Offene Stellen ansehen',

  'karriere.stellen.titel': 'Offene Stellen',

  'karriere.stelle-1.ort': { text: 'Gifhorn & Umgebung', max: 70 },
  'karriere.stelle-1.titel': 'Mitarbeiterin für Hauswirtschaft & Alltagsbegleitung',
  'karriere.stelle-1.text':
    'Wir suchen eine Mitarbeiterin für die hauswirtschaftliche Versorgung und Alltagsbegleitung. Wenn du freundlich und kompetent bist und Freude daran hast, pflegebedürftige Menschen im Alltag zu unterstützen, bist du bei uns genau richtig — attraktive Arbeitsbedingungen und flexible Arbeitszeiten inklusive.',
  'karriere.stelle-1.cta': 'Werde Teil unseres Teams',

  'karriere.stelle-2.ort': { text: 'Büro Gifhorn', max: 70 },
  'karriere.stelle-2.titel': 'Mitarbeiterin für Kundenbetreuung',
  'karriere.stelle-2.text':
    'Wir suchen eine engagierte Mitarbeiterin für die Kundenbetreuung. Wenn du kommunikativ bist und Freude daran hast, Kundenanliegen zu bearbeiten und unser Team im Büro zu unterstützen, passt du perfekt zu uns — mit attraktiven Arbeitsbedingungen und flexiblen Arbeitszeiten.',
  'karriere.stelle-2.cta': 'Werde Teil unseres Teams',

  'karriere.stelle-3.ort': {
    text: 'Region Braunschweig · Wolfsburg · Gifhorn · polnischsprachig',
    max: 90,
  },
  'karriere.stelle-3.titel': 'Koordynator Opiekunek Osób Starszych',
  'karriere.stelle-3.text':
    'Poszukujemy dynamicznej i zaangażowanej osoby na stanowisko Koordynatora Opiekunek Osób Starszych. Do zadań należy zarządzanie zespołem opiekunek, koordynowanie ich pracy, rekrutacja i szkolenie, tworzenie grafików oraz bliskie relacje z opiekunkami. Ważne, abyś mieszkał w regionie Braunschweig, Wolfsburg, Gifhorn i biegle posługiwał się językiem polskim.',
  'karriere.stelle-3.cta': 'Zostań częścią naszego zespołu',

  'karriere.initiativ.titel': 'Initiativ bewerben',
  'karriere.initiativ.text':
    'Keine passende Stelle dabei? Wir freuen uns immer über engagierte Menschen. Schick uns deine Kurzbewerbung — wir melden uns bei dir.',
};

export default KARRIERE;
